import * as React from 'react';
import {faChevronLeft, faTimes} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {ReactNode} from 'react';

interface FlyoutModalProps {
    children: ReactNode;
    e2e?: string;
    isSubMenu?: boolean;
    onClose: () => void;
    resetMenu?: () => void;
    show: boolean;
    title: string;
    width?: number;
}

const FlyoutMenu = ({children, e2e, isSubMenu = false, onClose, resetMenu, show, title, width = 540}: FlyoutModalProps) => {
    const contents = (
        <>
            <div className="tw-flex tw-justify-between tw-border-b tw-items-center tw-px-4 tw-pt-2 tw-pb-1">
                <div className="tw-flex tw-items-center">
                    {isSubMenu && (
                        <FontAwesomeIcon
                            className="tw-text-gray-700 tw-cursor-pointer tw-mr-4 tw-py-2"
                            icon={faChevronLeft}
                            onClick={() => {
                                resetMenu();
                            }}
                            size="xl"
                        />
                    )}
                    <div className="tw-m-0 tw-font-bold tw-text-[calc(1.275rem+0.3vw)] tw-mb-w tw-leading-[1.2]">{title}</div>
                </div>
                <FontAwesomeIcon
                    className="tw-text-gray-700 tw-cursor-pointer tw-p-2"
                    icon={faTimes}
                    onClick={() => {
                        onClose();
                    }}
                    size="2xl"
                />
            </div>
            <div className="tw-p-0 tw-overflow-x-hidden tw-h-[calc(100vh-62px)] tw-text-base">{children}</div>
        </>
    );

    /**
     * Template
     */
    return (
        <div className="tw-transition-all tw-duration-300 tw-ease-in-out">
            <div
                className={`tw-opacity-0 tw-transition-opacity tw-duration-200 tw-ease-in ${
                    show
                        ? 'tw-block tw-bg-gray-700 tw-opacity-50 tw-h-full tw-bottom-0 tw-fixed tw-top-0 tw-w-full tw-z-[1026] tw-left-0 tw-right-0 tw-transition-opacity tw-ease-in-out'
                        : 'tw-hidden'
                }`}
                onClick={() => {
                    onClose();
                }}
            ></div>
            <div
                data-e2e={e2e}
                className={`tw-overflow-x-hidden tw-transition-all tw-duration-300 tw-ease-in-out ${
                    show
                        ? 'tw-block tw-bg-white tw-w-4/5 tw-h-[100vh] tw-max-h-[100vh] tw-fixed tw-top-0 tw-right-0 tw-z-[1040]'
                        : 'tw-hidden'
                }`}
                style={{maxWidth: width, transform: show ? `translate3d(0vw, 0, 0)` : `translate3d(${width}px, 0, 0)`}}
            >
                {contents}
            </div>
        </div>
    );
};

export {FlyoutMenu};
